import React from 'react';
import ReactModal from 'react-modal';
import {X} from 'react-feather';
import Button, {InvertedButton} from '../output/Button';
import './Modal.css';
import PropTypes from 'prop-types';
import getLabel from '../../translations/messages';

export const ConfirmModal = (props, context) => (
  <ReactModal
      isOpen={props.isOpen}
      contentLabel={getLabel(context.locale, props.title)}
      className="Modal"
      overlayClassName="Overlay"
      ariaHideApp={false}>
    <div className="header">
      <div className="left">{getLabel(context.locale, props.title)}</div>
      <div className="right">
        <a onClick={props.handleCloseModal}><X /></a>
      </div>
    </div>
    <div className="container">
      {props.children}
    </div>
    <div className="footer">
      <InvertedButton onClick={props.handleCloseModal}>{getLabel(context.locale, 'general.close')}</InvertedButton>
      <Button onClick={props.submitAction} disabled={props.disabled === undefined ? false : props.disabled}>{getLabel(context.locale, 'general.confirm')}</Button>
    </div>
  </ReactModal>
);

ConfirmModal.contextTypes = {
  locale: PropTypes.string,
};

const Modal = (props, context) => (
  <ReactModal
      isOpen={props.isOpen}
      contentLabel={props.title}
      className="Modal"
      overlayClassName="Overlay"
      ariaHideApp={false}>
    <div className="header">
      <div className="left">{getLabel(context.locale, props.title)}</div>
      <div className="right">
        <a onClick={props.handleCloseModal}><X /></a>
      </div>
    </div>
    <div className="container">
      {props.children}
    </div>
    <div className="footer">
      <Button onClick={props.handleCloseModal}>
        {props.closeButtonMessage ? props.closeButtonMessage : getLabel(context.locale, 'general.close')}
      </Button>
    </div>
  </ReactModal>
);

Modal.contextTypes = {
  locale: PropTypes.string,
};

export const ConfirmDisableModal = (props, context) => (
		  <ReactModal
		      isOpen={props.isOpen}
		      contentLabel={getLabel(context.locale, props.title)}
		      className="Modal"
		      overlayClassName="Overlay"
		      ariaHideApp={false}>
		    <div className="header">
		      <div className="left">{getLabel(context.locale, props.title)}</div>
		      <div className="right">
		        <a onClick={props.handleCloseModal}><X /></a>
		      </div>
		    </div>
		    <div className="container">
		      {props.children}
		    </div>
		    <div className="footer">
		      <InvertedButton onClick={props.handleCloseModal}>{getLabel(context.locale, 'general.close')}</InvertedButton>
		      <Button onClick={props.submitAction}>{getLabel(context.locale, 'general.confirm')}</Button>
		    </div>
		  </ReactModal>
		);


ConfirmDisableModal.contextTypes = {
  locale: PropTypes.string,
};

export default Modal;



// WEBPACK FOOTER //
// ./src/main/components/container/Modal.js